(() => {
  const init = async root => {
    const section = root.querySelector('[data-gallery-collection]');
    if (!section || section.dataset.initialized) return;
    section.dataset.initialized = 'true';
    const form = section.querySelector('[data-gallery-filters]');
    const grid = section.querySelector('[data-gallery-works]');
    const status = section.querySelector('[data-gallery-count]');
    const sort = section.querySelector('[data-gallery-sort]');
    const active = section.querySelector('[data-gallery-active-filters]');
    const empty = section.querySelector('[data-gallery-empty]');
    const params = new URLSearchParams(location.search);
    let selection = params.get('selection') || '';
    // Additional catalog pages are fetched before filtering so matches span the collection.
    let next = section.querySelector('[data-gallery-next]');
    if (next) {
      form.querySelectorAll('input,select,button').forEach(el => el.disabled = true);
      status.textContent = 'Loading the complete collection…';
      try {
        let nextURL = next.href;
        const seen = new Set();
        while (nextURL && !seen.has(nextURL)) {
          seen.add(nextURL);
          const url = new URL(nextURL);
          url.searchParams.set('section_id', section.dataset.sectionId);
          const response = await fetch(url);
          if (!response.ok) throw new Error('Collection request failed');
          const doc = new DOMParser().parseFromString(await response.text(),'text/html');
          const extra = doc.querySelector('[data-gallery-collection]');
          if (!extra) throw new Error('Collection response unavailable');
          extra.querySelectorAll('[data-gallery-card]').forEach(card => grid.appendChild(card));
          const link = extra.querySelector('[data-gallery-next]');
          nextURL = link ? new URL(link.getAttribute('href'), location.href).href : null;
        }
        next.remove();
      } catch {
        status.textContent = 'The full collection could not load. Use “More works” to continue browsing.';
        return;
      }
      form.querySelectorAll('input,select,button').forEach(el => el.disabled = false);
    }
    const cards = [...grid.querySelectorAll('[data-gallery-card]')];
    cards.forEach((card,i) => { card.dataset.order = String(i); ['artist','medium','size','title','selection'].forEach(key => { card.dataset[key] = (card.dataset[key] || '').trim(); }); });
    form.querySelectorAll('[data-gallery-options]').forEach(select => {
      const key = select.dataset.galleryOptions;
      const choices = [...new Set(cards.map(c => c.dataset[key]).filter(Boolean))].sort();
      if (key === 'size') choices.sort((a,b) => ['Small','Medium','Large','Size not listed'].findIndex(x=>a.startsWith(x))-['Small','Medium','Large','Size not listed'].findIndex(x=>b.startsWith(x)));
      choices.forEach(value => select.add(new Option(value,value)));
    });
    const labels = {artist:'Artist',medium:'Medium',size:'Size',min:'From',max:'To',availability:'Availability'};
    const fields = Object.keys(labels);
    const syncFromURL = () => {
      const p = new URLSearchParams(location.search);
      fields.forEach(key => { const el = form.elements.namedItem(key); el.value = p.get(key) || ''; });
      sort.value = p.get('sort') || 'featured';
      if (!sort.value) sort.value = 'featured';
      selection = p.get('selection') || '';
    };
    const apply = (updateURL = true) => {
      const values = Object.fromEntries(fields.map(key=>[key,form.elements.namedItem(key).value.trim()]));
      const min = values.min === '' ? -Infinity : Number(values.min);
      const max = values.max === '' ? Infinity : Number(values.max);
      form.elements.namedItem('max').setCustomValidity(max < min ? 'Choose a maximum price at least as high as the minimum.' : '');
      if (!form.reportValidity()) return;
      const visible = cards.filter(card => {
        const d=card.dataset;
        return (!values.artist || values.artist===d.artist) && (!values.medium || values.medium===d.medium) && (!values.size || values.size===d.size) && Number(d.price)>=min && Number(d.price)<=max && (!values.availability || (values.availability==='available')===(d.available==='true')) && (!selection || d.selection===selection);
      });
      const visibleSet=new Set(visible);
      const comparators = {
        featured:(a,b)=>Number(a.dataset.order)-Number(b.dataset.order),
        'price-asc':(a,b)=>Number(a.dataset.price)-Number(b.dataset.price),
        'price-desc':(a,b)=>Number(b.dataset.price)-Number(a.dataset.price),
        title:(a,b)=>a.dataset.title.localeCompare(b.dataset.title),
        artist:(a,b)=>a.dataset.artist.localeCompare(b.dataset.artist)||a.dataset.title.localeCompare(b.dataset.title)
      };
      [...cards].sort(comparators[sort.value]||comparators.featured).forEach(card=>{card.hidden=!visibleSet.has(card);grid.appendChild(card);});
      status.textContent=`${visible.length} ${visible.length===1?'work':'works'}${visible.length!==cards.length?` of ${cards.length}`:''}`;
      empty.hidden=visible.length>0;
      active.replaceChildren();
      const chip=(text,fn)=>{const b=document.createElement('button');b.type='button';b.textContent=`${text} ×`;b.addEventListener('click',fn);active.appendChild(b);};
      fields.forEach(key=>{if(values[key])chip(`${labels[key]}: ${values[key]}`,()=>{form.elements.namedItem(key).value='';apply();});});
      if(selection)chip(({versace:'Versace portraits',gordiets:'Gordiets’s worlds',ballerinas:'Ballerinas'})[selection]||selection,()=>{selection='';apply();});
      if(updateURL){const url=new URL(location.href);fields.forEach(key=>values[key]?url.searchParams.set(key,values[key]):url.searchParams.delete(key));selection?url.searchParams.set('selection',selection):url.searchParams.delete('selection');sort.value==='featured'?url.searchParams.delete('sort'):url.searchParams.set('sort',sort.value);url.searchParams.delete('page');history.replaceState(null,'',url);}
    };
    form.addEventListener('submit',e=>{e.preventDefault();apply();});
    form.querySelectorAll('input[type="number"]').forEach(input=>input.addEventListener('input',()=>form.elements.namedItem('max').setCustomValidity('')));
    form.querySelectorAll('select').forEach(select=>select.addEventListener('change',()=>apply()));
    sort.addEventListener('change',()=>apply());
    section.querySelectorAll('[data-gallery-clear]').forEach(a=>a.addEventListener('click',e=>{e.preventDefault();form.reset();selection='';sort.value='featured';apply();}));
    window.addEventListener('popstate',()=>{syncFromURL();apply(false);});
    syncFromURL();apply(false);
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(document),{once:true});else init(document);
  document.addEventListener('shopify:section:load',event=>init(event.target));
})();
